import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

type ProfileCardActionsProps = {
  onShare: () => void;
  onDownload: () => void;
  disabled?: boolean;
  showShareButton?: boolean;
  showDownloadButton?: boolean;
};

const ProfileCardActions = ({
  onShare,
  onDownload,
  disabled = false,
  showShareButton = true,
  showDownloadButton = true,
}: ProfileCardActionsProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      {showShareButton && (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={onShare}
          disabled={disabled}
          sx={(theme) => ({
            borderColor: disabled
              ? `${theme.palette.grey[600]} !important`
              : 'undefined',
            marginTop: theme.spacing(spacingSizeMap.S),
          })}
        >
          {t('ui.event-management.learner.profiles.share')}
        </Button>
      )}
      {showDownloadButton && (
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={onDownload}
          disabled={disabled}
          sx={(theme) => ({
            borderColor: disabled
              ? `${theme.palette.grey[600]} !important`
              : 'undefined',
            borderWidth: '2px',
            marginTop: showShareButton
              ? theme.spacing(spacingSizeMap.XS)
              : theme.spacing(spacingSizeMap.L),
          })}
        >
          {t('ui.event-management.learner.profiles.download')}
        </Button>
      )}
    </Box>
  );
};

export default ProfileCardActions;
